import { FRACTIONS } from '@/utils/constants/drs/fractions'
import { getSealRequirements, resolveSealWarning } from '@/helpers/seal-validation'

export default {
    computed: {
        operatorName() {
            return this.bag.selectedOperator?.name || '---'
        },

        shouldHighlightSealPrefix() {
            const operator = this.bag.selectedOperator

            // Own transport has no operator prefix, so the first two digits stay plain
            return this.bag.seal_number && operator && operator.id !== 'OWN_TRANSPORT'
        },

        isOpen() {
            return !this.bag.isClosed
        },

        total() {
            return this.$options.filters.currency(this.bag.value / 100)
        },

        quantity() {
            return this.bag.quantity
        },

        fraction() {
            return Object.values(FRACTIONS).find(f => f.id === this.bag.fractionTypeId) || null
        },

        sealInput() {
            // Data for the checklist and the warning
            return {
                sealNumber: this.sealNumber,
                preferredPrefix: this.bag.preferredOperator?.prefix,
                knownPrefixes: this.$store.getters['drsBags/validSealPrefixes'],
                services: this.$store.state.drsBags?.services
            }
        },

        sealRequirements() {
            return getSealRequirements(this.sealInput)
        },

        sealWarning() {
            return resolveSealWarning(this.sealInput)
        }
    },

    methods: {
        digitsOnly(value) {
            if (value == null) return value
            return String(value).replace(/\D/g, '')
        },

        operatorReportStatus(report) {
            if (!report) {
                return {
                    icon: 'Ban',
                    class: 'text-muted',
                    message: 'Brak informacji o statusie'
                }
            }

            const code = Number(report.processing_result)

            if (code >= 200 && code <= 299) {
                return {
                    icon: 'Ok',
                    message: 'Status prawidłowy'
                }
            }

            return {
                icon: 'WarningFull',
                class: 'text-orange',
                message: 'Wystąpił problem',
                error: report.result_message || null
            }
        }
    }
}